/**
 * SleepScreen.jsx
 * Sleep tracking screen
 */
import React from 'react';
import { Moon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SleepScreen = () => (
  <div className="p-4 space-y-4">
    <h1 className="text-white text-xl font-bold pt-2">Schlaf-Tracking</h1>

    {/* Tonight's Goal */}
    <div className="bg-gradient-to-br from-indigo-500/20 to-purple-500/20 rounded-2xl p-4">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-zinc-400 text-sm">Ziel heute Nacht</p>
          <p className="text-white text-3xl font-bold mt-1">8h 0min</p>
        </div>
        <Moon className="w-10 h-10 text-indigo-400" />
      </div>
      <div className="mt-4 flex gap-4">
        <div>
          <p className="text-zinc-400 text-xs">Schlafenszeit</p>
          <p className="text-white font-medium">22:30</p>
        </div>
        <div>
          <p className="text-zinc-400 text-xs">Aufwachen</p>
          <p className="text-white font-medium">06:30</p>
        </div>
      </div>
    </div>

    {/* Weekly Chart */}
    <div className="bg-zinc-800/50 rounded-2xl p-4">
      <h2 className="text-white font-medium mb-4">Diese Woche</h2>
      <div className="flex justify-between items-end h-24">
        {['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'].map((day, i) => (
          <div key={day} className="flex flex-col items-center gap-1">
            <div 
              className={`w-6 rounded-t-lg ${i === 6 ? 'bg-zinc-700' : 'bg-indigo-500'}`}
              style={{ height: `${[65, 75, 70, 80, 60, 85, 0][i]}%` }}
            />
            <span className="text-zinc-500 text-xs">{day}</span>
          </div>
        ))}
      </div>
    </div>

    {/* Stats */}
    <div className="grid grid-cols-2 gap-3">
      <div className="bg-zinc-800/50 rounded-xl p-4">
        <p className="text-zinc-400 text-sm">Durchschnitt</p>
        <p className="text-white text-xl font-bold">7h 23min</p>
      </div>
      <div className="bg-zinc-800/50 rounded-xl p-4">
        <p className="text-zinc-400 text-sm">Qualität</p>
        <p className="text-white text-xl font-bold">82%</p>
      </div>
    </div>
  </div>
);

export default SleepScreen;
